import Vue from 'vue';
import Router from 'vue-router';

import store from './store';

import Studies from './pages/Studies.vue';
import Groups from './pages/Groups.vue';
import Dashboard from './pages/Dashboard.vue';
import NotFound from './pages/NotFound.vue';
import Login from './pages/Login.vue';

Vue.use(Router);

const router = new Router({
    mode: 'history',

    routes: [
        {
            path: '/admin/login',
            name: 'login',
            component: Login,
            meta: {
                layout: 'admin',
                requiresAuth: false,
            },
        },

        {
            path: '/admin/studies',
            alias: '/',
            name: 'studies',
            component: Studies,
            meta: {
                layout: 'admin',
                requiresAuth: true,
            },
        },

        {
            path: '/admin/groups',
            name: 'groups',
            component: Groups,
            meta: {
                layout: 'admin',
                requiresAuth: true,
            },
        },

        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            meta: {
                layout: 'empty',
                requiresAuth: false,
            },
        },

        {
            path: '/404',
            alias: '*',
            name: '404',
            component: NotFound,
            meta: {
                layout: 'error',
                requiresAuth: false,
            },
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (!store.getters.isLoggedIn) {
            next({ name: 'login' });
        } else {
            next();
        }
    }

    next();
});

export default router;
